import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { INFINITY_CHAR } from '@services/helper.service';

import Input from '@components/Input';

import { APP_TYPES } from '@config';

import SafetyBarrierObject from '../../../../object-view/generators/safety-barrier/safety-barrier.object';
import { setGroundC1x, setGroundC2x, setGroundC1y, setGroundC2y } from '@reducers/options/ground/actions';

import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';

class EdgeDistance extends Component {

  static propTypes = {
    padding: PropTypes.object.isRequired,
    options: PropTypes.shape().isRequired
  };

  render() {
    return (
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_EDGE_DISTANCE.Content}>
      <div>
        <div className="base-plate__row">
          {this.isC1x && (
            <Input
              className="base-plate__input"
              prefix="C1x ="
              postfix={unitLabel(this.props.unit)}
              id="c1x"
              type="number"
              minValue={0}
              value={typeof this.props.padding.C1x === 'number' ? 
                unitTransform(this.props.padding.C1x).from(defaultUnits.DISTANCE).to(this.props.unit) : null}
              placeholder={placeholderIsNeeded(this.props.padding.C1x)}
              onUpdate={value => {
                this.props.setC1x(value, this.props.unit);
              }}
            />
          )}

          {this.isC1y && (
            <Input
              className="base-plate__input"
              prefix="C1y ="
              postfix={unitLabel(this.props.unit)}
              id="c1y"
              type="number"
              minValue={0}
              value={typeof this.props.padding.C1y === 'number' ? 
                unitTransform(this.props.padding.C1y).from(defaultUnits.DISTANCE).to(this.props.unit) : null}
              placeholder={placeholderIsNeeded(this.props.padding.C1y)}
              onUpdate={value => {
                this.props.setC1y(value, this.props.unit);
              }}
            />
          )}
        </div>

        <div className="base-plate__row">
          {this.isC2x && (
            <Input
              className="base-plate__input"
              prefix="C2x ="
              postfix={unitLabel(this.props.unit)}
              id="c2x"
              type="number"
              minValue={0}
              value={typeof this.props.padding.C2x === 'number' ? 
                unitTransform(this.props.padding.C2x).from(defaultUnits.DISTANCE).to(this.props.unit) : null}
              placeholder={placeholderIsNeeded(this.props.padding.C2x)}
              onUpdate={value => {
                this.props.setC2x(value, this.props.unit);
              }}
            />
          )}

          {this.isC2y && (
            <Input
              className="base-plate__input"
              prefix="C2y ="
              postfix={unitLabel(this.props.unit)}
              id="c2y"
              type="number"
              minValue={0}
              value={typeof this.props.padding.C2y === 'number' ? 
                unitTransform(this.props.padding.C2y).from(defaultUnits.DISTANCE).to(this.props.unit) : null}
              placeholder={placeholderIsNeeded(this.props.padding.C2y)}
              onUpdate={value => {
                this.props.setC2y(value, this.props.unit);
              }}
            />
          )}
        </div>
      </div>
      </Tooltip>
    );
  }

  get isC1x() {
    return (
      this.props.appType === APP_TYPES.GENERAL_CALCULATION ||
      this.props.appType === APP_TYPES.BRACKET_ATTACHMENT || 
      this.props.appType === APP_TYPES.WOOD_CONNECTION || 
      (
        this.props.appType === APP_TYPES.SAFETY_BARRIER &&
        this.props.options.object.type !== SafetyBarrierObject.types.FLOOR_SLAB && (
          this.props.options.object.type === SafetyBarrierObject.types.STAIRS ||
          this.props.options.object.type === SafetyBarrierObject.types.BETWEEN_WALLS
        )
      )
    );
  }

  get isC1y() {
    return (
      this.props.appType === APP_TYPES.GENERAL_CALCULATION || 
      this.props.appType === APP_TYPES.BRACKET_ATTACHMENT ||  
      this.props.appType === APP_TYPES.WOOD_CONNECTION || 
      (
        this.props.appType === APP_TYPES.SAFETY_BARRIER &&
        this.props.options.object.type !== SafetyBarrierObject.types.BETWEEN_WALLS && (
          this.props.options.object.type === SafetyBarrierObject.types.FLOOR_SLAB ||
          this.props.options.object.type === SafetyBarrierObject.types.STAIRS
        )
      )
    );
  }

  get isC2x() {
    return (
      this.props.appType === APP_TYPES.GENERAL_CALCULATION ||
      this.props.appType === APP_TYPES.BRACKET_ATTACHMENT || 
      (
        this.props.appType === APP_TYPES.SAFETY_BARRIER &&
        this.props.options.object.type !== SafetyBarrierObject.types.FLOOR_SLAB &&
        this.props.options.object.type !== SafetyBarrierObject.types.STAIRS &&
        this.props.options.object.type !== SafetyBarrierObject.types.BETWEEN_WALLS
      )
    );
  }

  get isC2y() {
    return (
      this.props.appType === APP_TYPES.GENERAL_CALCULATION ||
      this.props.appType === APP_TYPES.BRACKET_ATTACHMENT ||  
      this.props.appType === APP_TYPES.WOOD_CONNECTION || 
      (
        this.props.appType === APP_TYPES.SAFETY_BARRIER &&
        this.props.options.object.type !== SafetyBarrierObject.types.FLOOR_SLAB &&
        this.props.options.object.type !== SafetyBarrierObject.types.STAIRS &&
        this.props.options.object.type !== SafetyBarrierObject.types.BETWEEN_WALLS
      )
    );
  }

}

const mapState = state => {
  const unit = state.main.units.distance;

  return {
    appType: state.main.appType,
    options: state.options,
    padding: state.options.ground.padding || {
      C1x: null, // Null = ∞ char in UI
      C2x: null,
      C1y: null,
      C2y: null,
    },
    unit
  };
};

const mapDispatch = dispatch => ({
  setC1x: (value, unit) => 
    dispatch(setGroundC1x(value !== '' ? unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE) : null)),
  setC1y: (value, unit) => 
    dispatch(setGroundC1y(value !== '' ? unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE) : null)),
  setC2x: (value, unit) => 
    dispatch(setGroundC2x(value !== '' ? unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE) : null)),
  setC2y: (value, unit) => 
    dispatch(setGroundC2y(value !== '' ? unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE) : null))
});

export default connect(mapState, mapDispatch)(EdgeDistance);

function placeholderIsNeeded(value) {
  return value === null ? INFINITY_CHAR : null;
}



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/EdgeDistance.js